// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"63c1c8ac","266":"ce8e39d9","363":"4345b190","408":"28d997ec"}[chunkId] + ".chunk.css";
};